module.exports = __webpack_public_path__ + "img/logo_tanpa_tulisan.720bc413.png";